import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';
import About from '../components/About';
import Guides from '../components/Guides';
import FAQ from '../components/FAQ';
import News from '../components/News';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Home = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Regal Play',
    url: 'https://regal-play.com',
    description: 'Expert UK casino reviews and comparison platform providing trusted information about online casinos, bonuses, and comprehensive gambling guides for UK players.',
    publisher: {
      '@type': 'Organization',
      name: 'Regal Play',
      logo: {
        '@type': 'ImageObject',
        url: 'https://regal-play.com/images/favicon.webp',
      },
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://regal-play.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <div className="min-h-screen bg-regal-dark">
      <SEO
        title="Expert UK Casino Reviews & Exclusive Bonus Offers"
        description="Discover the best UK online casinos with Regal Play. Expert reviews, exclusive bonuses, and comprehensive guides to help you find trusted casino platforms. 18+ only. Play responsibly."
        keywords="UK online casinos, casino reviews, casino bonuses, online gambling UK, casino guides, best UK casinos, casino comparison"
        canonical="/"
        jsonLd={jsonLd}
      />
      <Header />
      <Hero />
      <Offers />
      <About />
      <Guides />
      <FAQ />
      <News />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;

